import apiClient from "./axios";

export const getBrands = async (params = {}) => {
  const { data } = await apiClient.get("/brands", { params });
  return data;
};

export const getBrand = async id => {
  const { data } = await apiClient.get(`/brands/${id}`)
  return data
}

export const createBrand = async brandData => {
  const { data } = await apiClient.post("/brands", brandData)
  return data
}

export const editBrand = async ({ id, ...brandData }) => {
  const { data } = await apiClient.patch(`/brands/${id}`, brandData)
  return data
}

export const deleteBrand = async id => {
  const { data } = await apiClient.delete(`/brands/${id}`)
  return data
}
